import { Cell } from './cell.model';

export class DirectionalCell extends Cell {
    aboveCellId: string;
    belowCellId: string;      
    leftCellId: string;    
    rightCellId: string;
}